export const NAME = 'AirportDeparturesArrivals';
